document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.subscription-popup__blocks');
  const saveBtn = document.getElementById('save-preferences');
  const popupForm = document.getElementById('PopupLocalizationForm');
//   console.log(popupForm);
  if (popupForm && popupForm.parentElement) {
    popupForm.parentElement.classList.remove('flex', 'flex-wrap', 'text-center');
  }

  // Check if user has already set preferences
  if (!localStorage.getItem('preferencesSet')) {
    showPopup();
  }

  function showPopup() {
    popup.style.display = 'flex';
  }

  function hidePopup() {
    popup.style.display = 'none';
  }

  function saveLocalizationPreferences() {
     const langEl = document.getElementById('language');
  const countryEl = document.getElementById('country');
  if (!langEl || !countryEl) return;

  const language = langEl.value;
  const country = countryEl.value;

  // Save locally to prevent showing popup again
  window.FoxTheme.utils.setStorage(this.cookieName, { opened: true, language, country }, 7);
  
  // Let the form handle submission (Shopify’s backend does the rest)
  document.getElementById('PopupLocalizationForm').submit();
 }

  // Save button click handler
  if (saveBtn) {
    saveBtn.addEventListener('click', (e) => {
      e.preventDefault();
      saveLocalizationPreferences();
    });
  }
});
